/* HappyPets – varianter på vanliga produktsidor */
(function () {
  'use strict';
  function money(c) {
    var n = Math.round(c) / 100, w = Math.abs(n - Math.round(n)) < 0.005;
    var s = (w ? Math.round(n).toString() : n.toFixed(2)).replace('.', ',').split(',');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return s.join(',') + '\u00a0kr';
  }
  document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
    var picker = pdp.querySelector('[data-variant-picker]');
    var pjson = pdp.querySelector('[data-product-json]');
    var form = pdp.querySelector('[data-product-form]');
    if (!picker || !pjson || !form) return;
    var prod; try { prod = JSON.parse(pjson.textContent); } catch (e) { return; }
    var atc = form.querySelector('[data-atc]'), atcText = form.querySelector('[data-atc-text]'), atcPrice = form.querySelector('[data-atc-price]');
    var priceEl = pdp.querySelector('[data-price]'), cmpEl = pdp.querySelector('[data-compare]');
    var label = atcText ? atcText.textContent : '';
    picker.addEventListener('change', function () {
      var opts = Array.prototype.map.call(picker.querySelectorAll('select'), function (s) { return s.value; });
      var v = prod.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      if (!v) { if (atc) atc.disabled = true; if (atcText) atcText.textContent = 'Ej tillgänglig'; return; }
      form.querySelector('[name="id"]').value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) { var sale = v.compare_at_price > v.price; cmpEl.hidden = !sale; cmpEl.textContent = sale ? money(v.compare_at_price) : ''; }
      if (atcPrice) atcPrice.textContent = money(v.price);
      if (atc) atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? label : 'Slutsåld';
      if (v.featured_media) {
        var idx = (prod.media || []).map(function (m) { return m.id; }).indexOf(v.featured_media.id);
        var track = pdp.querySelector('[data-gallery-track]');
        var slide = track && track.children[idx];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
    });
  });
})();

/* Mobilmeny: stäng menyn när man trycker på en länk, och scrolla till ankare på samma sida */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var nav = a.closest('[data-mobile-nav]');
    var url; try { url = new URL(a.href, location.href); } catch (err) { return; }
    var samePage = url.pathname === location.pathname && url.hash;
    var target = samePage ? document.getElementById(url.hash.slice(1)) : null;
    if (nav) {
      nav.classList.remove('is-open');
      document.documentElement.classList.remove('menu-open');
      var btn = document.querySelector('[data-menu-toggle][aria-controls="' + nav.id + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try { history.replaceState({}, '', url.hash); } catch (err) {}
    }
  });
})();
